<template>
  <div class="premade-container">
    <PremadeBlocks
      v-if="showPremadeBlocks && premadeBlocks"
      :clickable="clickable"
      :premade-blocks="premadeBlocks"
      @premade-clicked="premadeClick"
      @back-to-premades="showPremadeBlocks = false"
    />
    <div v-else class="space-y-2">
      <div
        v-if="premadeBlocks && premadeBlocks.length > 0"
        class="group flex cursor-pointer items-center justify-between rounded-md bg-gray-600 p-2 font-inter text-[13px] font-medium text-gray-100 transition duration-300 hover:bg-gray-500 hover:text-gray-50"
        @click="showPremadeBlocks = true"
      >
        <div class="flex items-center gap-2 leading-6">
          <font-awesome-icon :icon="['fas', 'shapes']" class="w-[20px]" />
          <p>{{ $t("blocks.premade_blocks") }}</p>
        </div>
        <t-button>
          <template #icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6387 10.4512C12.8848 10.2051 12.8848 9.79492 12.6387 9.54883L8.91992 5.83008C8.64648 5.55664 8.23633 5.55664 7.99023 5.83008L7.36133 6.43164C7.11523 6.70508 7.11523 7.11523 7.36133 7.36133L10.0137 10.0137L7.36133 12.6387C7.11523 12.8848 7.11523 13.2949 7.36133 13.5684L7.99023 14.1699C8.23633 14.4434 8.64648 14.4434 8.91992 14.1699L12.6387 10.4512Z"
                fill="currentColor"
              />
            </svg>
          </template>
        </t-button>
      </div>
      <PremadeTemplates v-if="premadeTemplates" @closeDialog="closeDialog" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import PremadeTemplates from "./PremadeTemplates/PremadeTemplates.vue";
  import PremadeBlocks from "./PremadeBlocks/PremadeBlocks.vue";
  import { BlockClickedEvent } from "types/ContentBlock/IContentBlockOptions";
  import type { IPremadeBlock } from "types/Premadeblocks/IPremadeBlocks";
  import { usePremadeBlocksStore } from "@/stores/premadeBlocksStore";
  import { usePremadeTemplatesStore } from "@/stores/premadeTemplatesStore";
  import { useGeneralStore } from "@/stores/generalStore";

  import czpremadeblocks from "@/store/premadeblocks/czpremadeblocks";
  import premadeblocks from "@/store/premadeblocks/premadeblocks";

  import { TButton } from "@topol/twig-ui";

  import { computed, ref, onMounted } from "vue";

  const showPremadeBlocks = ref(true);

  defineProps({
    clickable: {
      type: Boolean,
      default: false,
    },
  });

  const premadeBlocksStore = usePremadeBlocksStore();
  const { premadeTemplates } = usePremadeTemplatesStore();
  const generalStore = useGeneralStore();

  const closeDialog = () => {
    emits("closeDialog");
  };

  const premadeBlocks = computed((): IPremadeBlock[] | false => {
    const blocks = premadeBlocksStore.premadeBlocks;

    if (!blocks) {
      return false;
    }

    // In the new shape, there is specific name key for each premadeblock,
    // so here we can distinguish if it's legacy or new shape
    if (Array.isArray(blocks)) {
      return blocks;
    }

    const convertedBlocks =
      premadeBlocksStore.convertLegacyPremadeBlocks(blocks);

    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    premadeBlocksStore.premadeBlocks = convertedBlocks;

    return convertedBlocks;
  });

  const emits = defineEmits(["premade-clicked", "closeDialog"]);

  const premadeClick = (typeObject: BlockClickedEvent) => {
    emits("premade-clicked", typeObject);
  };

  onMounted(() => {
    //checking if premadeblocks are defined using PluginAPI

    if (
      generalStore.language === "cs" &&
      premadeBlocksStore.premadeBlocks === null
    ) {
      premadeBlocksStore.premadeBlocks = czpremadeblocks;
    } else if (
      generalStore.language !== "cs" &&
      premadeBlocksStore.premadeBlocks === null
    ) {
      premadeBlocksStore.premadeBlocks = premadeblocks;
    }
  });
</script>
<style lang="scss"></style>
